import React from "react";
import PropTypes from "prop-types";
import { connect } from "unistore/preact";
import { actions } from "actions";
import { stringReplace, isFlexMatrix } from "utils";
import FlexMatrixQuestion from "components/questions/FlexMatrixQuestion";
import MatrixQuestionRow from "components/questions/MatrixQuestionRow";
import MatrixQuestionColumnHeaders from "components/questions/MatrixQuestionColumnHeaders";

//FIXME: SOF-617 requires the following imports to be moved to components/widget-components.scss
// due to lazy loading of the widget inside an iframe. Keeping this here for potential fix down the road.
// import 'components/questions/MatrixQuestion.scss';

const MatrixQuestion = ({ question, onOptionChanged, isDisabled }) => {
  const { rows, columns, id, text } = question;
  const matrixId = stringReplace(id, "/", "-");

  return isFlexMatrix(question) ? (
    <FlexMatrixQuestion question={question} isDisabled={isDisabled} />
  ) : (
    <fieldset className="csw-fieldset csw-q-mtrx">
      <legend className="sr-only" aria-hidden={true}>
        {text}
      </legend>
      <MatrixQuestionColumnHeaders columns={columns} colId={`csw-q-mtrx-hdr-${matrixId}`} />

      {rows &&
        rows.map((row, index) => {
          const rowId = `${matrixId}-${index}`; // This must be uniq and include index

          return (
            <MatrixQuestionRow
              key={rowId}
              rowId={rowId}
              row={row}
              columns={columns}
              isDisabled={isDisabled}
              onOptionSelected={(option, row) => onOptionChanged({ option, row })}
            />
          );
        })}
    </fieldset>
  );
};

MatrixQuestion.propTypes /* remove-proptypes */ = {
  question: PropTypes.object.isRequired,
  onOptionChanged: PropTypes.func,
  isDisabled: PropTypes.bool,
};

export default connect("", actions)(MatrixQuestion);
